const intervalTime = 1000 * 60

let intervalId = null

function createKeepAlive(callback) {
  if (!keepAliveExists()) {
    intervalId = setInterval(() => {
      callback(intervalId)
    }, intervalTime)
  }
}

function keepAliveExists() {
  return intervalId !== null
}

function killKeepAlive() {
  clearInterval(intervalId)
  intervalId = null
}

export { createKeepAlive, killKeepAlive, keepAliveExists }
